import store from '../store/store';


export function setRootModuleState(appState) {
	console.log('setRootModuleState', getRootModulePath(), appState.toJS());
	store.dispatch({
		type: 'module.setModuleState',
		appStatePath: getRootModulePath(),
		appState
	});
}

export function setRootModuleData(data) {
	store.dispatch({
		type: 'module.setModuleData',
		appStatePath: getRootModulePath(),
		data
	});
}

export function getRootModulePath() {
	return ['rootModule'];
}
